import { render, staticRenderFns } from "./MbGameStatus.vue?vue&type=template&id=11ff736f&scoped=true&"
import script from "./MbGameStatus.vue?vue&type=script&lang=js&"
export * from "./MbGameStatus.vue?vue&type=script&lang=js&"
import style0 from "./MbGameStatus.vue?vue&type=style&index=0&id=11ff736f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ff736f",
  null
  
)

export default component.exports